<template>
  <Anicss
    appear
    :leaveActiveClass="['animated', 'fadeOut']"
  >
    <Modal style="animation-duration: 300ms;">
      <div :class="$style.body">
        <div>
          <label>名字</label>
          <Input v-model="name" />
        </div>
        <div>
          <label>電郵地址</label>
          <Input v-model="login" />
        </div>
        <div>
          <label>管理員</label>
          <input type="checkbox" v-model="isAdmin" />
        </div>
        <div>
          <label>密碼</label>
          <Input type="password" v-model="password" />
        </div>
      </div>
      <div :class="$style.footer">
        <div :class="$style.controls">
          <Button @click="change">儲存</Button>
          <Button @click="close">取消</Button>
        </div>
      </div>
    </Modal>
  </Anicss>
</template>

<script>
import Modal from '@/components/Modal'
import Anicss from '@/components/Anicss'
import Button from '@/components/Button'
import Input from './Input'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    Modal,
    Anicss,
    Button,
    Input,
  },
  props: {
    user: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      newUser: null,
      newPass: '',
    }
  },
  created () {
    this.cloneUser()
  },
  computed: {
    name: {
      get () {
        return this.newUser.name
      },
      set (val) {
        this.newUser.name = val
      },
    },
    login: {
      get () {
        return this.newUser.login
      },
      set (val) {
        this.newUser.login = val
      },
    },
    password: {
      get () {
        return this.newPass
      },
      set (val) {
        this.newPass = val
      },
    },
    isAdmin: {
      get () {
        return this.newUser.role == 'ADMIN'
      },
      set (val) {
        this.newUser.role = (val ? 'ADMIN' : '')
      },
    },
    role: {
      get () {
        return this.newUser.role
      },
      set (val) {
        this.newUser.role = val
      },
    },
  },
  methods: {
    cloneUser () {
      this.newUser = cloneDeep(this.user)
    },
    change () {
      const data = { ...this.newUser }
      if (this.newPass) {
        data.password = this.newPass
      }
      this.$emit('change', data)
    },
    close () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" module>
.body {
  > div {
    @apply mb-6;

    > label {
      @apply inline-block;
      @apply mb-2;
      @apply px-1;
    }
  }
}

.controls {
  @apply -mx-1;

  > button {
    @apply mx-1;
  }
}
</style>
